/* This file is auto-generated, manual edits in this file will be overwritten! */

export const i18nKeys = {
  a11y: {
    alert: 'a11y.alert',
    ariaLabel: {
      menu: 'a11y.ariaLabel.menu',
    },
    attention: 'a11y.attention',
    breadcrumb: {
      toggleArrow: 'a11y.breadcrumb.toggleArrow',
    },
    information: 'a11y.information',
    input: 'a11y.input',
    logo: 'a11y.logo',
    selectOption: 'a11y.selectOption',
    tableHeader: 'a11y.tableHeader',
    toolbar: 'a11y.toolbar',
    willExpire: 'a11y.willExpire',
  },
  alert: {
    frozen: {
      awaitingCorrection: {
        body: 'alert.frozen.awaitingCorrection.body',
      },
      awaitingRegionValidation: {
        body: 'alert.frozen.awaitingRegionValidation.body',
      },
      cta: {
        account: 'alert.frozen.cta.account',
        downloadTheApp: 'alert.frozen.cta.downloadTheApp',
        linkToPortal: {
          default: 'alert.frozen.cta.linkToPortal.default',
          format: 'alert.frozen.cta.linkToPortal.format',
        },
        ourHelpCenter: 'alert.frozen.cta.ourHelpCenter',
      },
      dead: {
        body: 'alert.frozen.dead.body',
        cta: 'alert.frozen.dead.cta',
      },
      inactiveNonUsage: {
        body: 'alert.frozen.inactiveNonUsage.body',
        cta: 'alert.frozen.inactiveNonUsage.cta',
      },
      deposed: {
        body: 'alert.frozen.deposed.body',
      },
      moveRegion: {
        body: {
          native: 'alert.frozen.moveRegion.body.native',
          web: 'alert.frozen.moveRegion.body.web',
        },
      },
      moveUnresolvedLocation: {
        body: 'alert.frozen.moveUnresolvedLocation.body',
      },
      refused: {
        notActive: {
          first: {
            body: 'alert.frozen.refused.notActive.first.body',
          },
          second: {
            body: 'alert.frozen.refused.notActive.second.body',
          },
        },
        otherRegion: {
          body: {
            native: 'alert.frozen.refused.otherRegion.body.native',
            web: 'alert.frozen.refused.otherRegion.body.web',
          },
        },
      },
      title: 'alert.frozen.title',
    },
    success: {
      fiscalAttestation: {
        body: 'alert.success.fiscalAttestation.body',
        cta: 'alert.success.fiscalAttestation.cta',
        title: 'alert.success.fiscalAttestation.title',
      },
    },
    switchFromPaper: {
      flanders: {
        title: 'alert.switchFromPaper.flanders.title',
        body: 'alert.switchFromPaper.flanders.body',
        disclaimer: 'alert.switchFromPaper.flanders.disclaimer',
      },
      body: 'alert.switchFromPaper.body',
      cta: 'alert.switchFromPaper.cta',
      errorTitle: 'alert.switchFromPaper.errorTitle',
      moreInfo: 'alert.switchFromPaper.moreInfo',
      successTitle: 'alert.switchFromPaper.successTitle',
      title: 'alert.switchFromPaper.title',
    },
    warning: {
      notEnoughVouchers: {
        body: 'alert.warning.notEnoughVouchers.body',
        cta: 'alert.warning.notEnoughVouchers.cta',
        title: 'alert.warning.notEnoughVouchers.title',
      },
    },
  },
  bl: {
    anysurfer: {
      a11y: 'bl.anysurfer.a11y',
      url: 'bl.anysurfer.url',
    },
    brps: {
      label: 'bl.brps.label',
      short_label: 'bl.brps.short_label',
      url: 'bl.brps.url',
    },
    general: {
      conditions: {
        url: 'bl.general.conditions.url',
      },
      electronicVoucher: {
        url: 'bl.general.electronicVoucher.url',
      },
      helpCenter: {
        link: 'bl.general.helpCenter.link',
        phone: 'bl.general.helpCenter.phone',
      },
      region: {
        name: 'bl.general.region.name',
      },
      serviceVouchers: {
        app: {
          label: 'bl.general.serviceVouchers.app.label',
        },
        helpCenter: {
          phoneNumber: 'bl.general.serviceVouchers.helpCenter.phoneNumber',
        },
        publicWebsite: {
          url: 'bl.general.serviceVouchers.publicWebsite.url',
        },
        website: {
          url: 'bl.general.serviceVouchers.website.url',
        },
      },
      url: {
        complaint: 'bl.general.url.complaint',
        contactAProvider: 'bl.general.url.contactAProvider',
        contactUs: 'bl.general.url.contactUs',
        cookies: 'bl.general.url.cookies',
        electronicVoucher: 'bl.general.url.electronicVoucher',
        exchange: 'bl.general.url.exchange',
        faq: 'bl.general.url.faq',
        news: 'bl.general.url.news',
        pass: 'bl.general.url.pass',
        privacyPolicy: 'bl.general.url.privacyPolicy',
        question: 'bl.general.url.question',
        termsAndConditions: 'bl.general.url.termsAndConditions',
        workFollowUp: 'bl.general.url.workFollowUp',
      },
    },
    header: {
      funcHeader: {
        cta: {
          backToInfoWebsite: {
            title: 'bl.header.funcHeader.cta.backToInfoWebsite.title',
          },
        },
      },
      support: {
        contactList: {
          callus: {
            description: 'bl.header.support.contactList.callus.description',
            title: 'bl.header.support.contactList.callus.title',
          },
          contactus: {
            description: 'bl.header.support.contactList.contactus.description',
            title: 'bl.header.support.contactList.contactus.title',
          },
          description: 'bl.header.support.contactList.description',
          findProvider: {
            description:
              'bl.header.support.contactList.findProvider.description',
            title: 'bl.header.support.contactList.findProvider.title',
          },
          helpCenter: {
            description: 'bl.header.support.contactList.helpCenter.description',
            title: 'bl.header.support.contactList.helpCenter.title',
          },
          pass: {
            description: 'bl.header.support.contactList.pass.description',
          },
          title: 'bl.header.support.contactList.title',
        },
      },
    },
    login: {
      cta: {
        forgotPassword: 'bl.login.cta.forgotPassword',
        register: 'bl.login.cta.register',
      },
      title: {
        notRegisterYet: 'bl.login.title.notRegisterYet',
      },
      url: {
        usefullLinks: {
          cantConnect: 'bl.login.url.usefullLinks.cantConnect',
          howTo: 'bl.login.url.usefullLinks.howTo',
        },
      },
    },
    register: {
      alert: {
        list: {
          livingIn: 'bl.register.alert.list.livingIn',
        },
      },
    },
    siteBar: {
      title: 'bl.siteBar.title',
    },
    switchProfile: {
      modal: {
        activeAccount: {
          title: 'bl.switchProfile.modal.activeAccount.title',
        },
        customerId: 'bl.switchProfile.modal.customerId',
        otherAccount: {
          title: 'bl.switchProfile.modal.otherAccount.title',
        },
        title: 'bl.switchProfile.modal.title',
      },
    },
  },
  blocked: {
    contractList: {
      goDashboard: 'blocked.contractList.goDashboard',
      title: 'blocked.contractList.title',
    },
    introduction: 'blocked.introduction',
    title: 'blocked.title',
  },
  contactUs: {
    availableSubjects: {
      BILLING_AND_TAX_RETURN_DOCUMENT:
        'contactUs.availableSubjects.BILLING_AND_TAX_RETURN_DOCUMENT',
      CUSTOMER_SUPPORT: 'contactUs.availableSubjects.CUSTOMER_SUPPORT',
      DELIVERY: 'contactUs.availableSubjects.DELIVERY',
      GDPR: 'contactUs.availableSubjects.GDPR',
      ORDERS: 'contactUs.availableSubjects.ORDERS',
      OTHER: 'contactUs.availableSubjects.OTHER',
      PROFILE_INFORMATION: 'contactUs.availableSubjects.PROFILE_INFORMATION',
      REFUND_AND_EXCHANGE: 'contactUs.availableSubjects.REFUND_AND_EXCHANGE',
      REGISTRATION: 'contactUs.availableSubjects.REGISTRATION',
      SERVICES: 'contactUs.availableSubjects.SERVICES',
      USER_ACCOUNT: 'contactUs.availableSubjects.USER_ACCOUNT',
    },
    confirm: {
      message: {
        body: {
          withEmail: 'contactUs.confirm.message.body.withEmail',
          withoutEmail: 'contactUs.confirm.message.body.withoutEmail',
        },
        title: {
          withEmail: 'contactUs.confirm.message.title.withEmail',
          withoutEmail: 'contactUs.confirm.message.title.withoutEmail',
        },
      },
      title: 'contactUs.confirm.title',
    },
    cta: {
      phone: 'contactUs.cta.phone',
      sendQuestion: 'contactUs.cta.sendQuestion',
    },
    messagePlaceHolder: 'contactUs.messagePlaceHolder',
    question: 'contactUs.question',
    sendMessage: 'contactUs.sendMessage',
    subject: 'contactUs.subject',
    title: 'contactUs.title',
  },
  dashboard: {
    cards: {
      vouchersStatus: {
        description: 'dashboard.cards.vouchersStatus.description',
        subDescription: 'dashboard.cards.vouchersStatus.subDescription',
        title: 'dashboard.cards.vouchersStatus.title',
      },
      wallet: {
        description: 'dashboard.cards.wallet.description',
        title: 'dashboard.cards.wallet.title',
      },
      workPending: {
        description: 'dashboard.cards.workPending.description',
        subDescription: 'dashboard.cards.workPending.subDescription',
        title: 'dashboard.cards.workPending.title',
      },
    },
    cta: {
      PRESTATIONS_WORKS_MANAGEMENT:
        'dashboard.cta.PRESTATIONS_WORKS_MANAGEMENT',
      SERVICES_VOUCHERS_WALLET: 'dashboard.cta.SERVICES_VOUCHERS_WALLET',
    },
    introduction: 'dashboard.introduction',
    title: 'dashboard.title',
  },
  dialog: {
    confirmClose: {
      message: 'dialog.confirmClose.message',
      title: 'dialog.confirmClose.title',
    },
    enterPostcodeFirst: 'dialog.enterPostcodeFirst',
    expireConfirm: {
      cta: 'dialog.expireConfirm.cta',
      title: 'dialog.expireConfirm.title',
    },
    logout: {
      message: 'dialog.logout.message',
    },
  },
  error: {
    loginErrorUserNotBelgian: 'error.loginErrorUserNotBelgian',
    loginErrorUserNotFound: 'error.loginErrorUserNotFound',
    loginErrorAccountBlocked: 'error.loginErrorAccountBlocked',
    loginUnknownError: 'error.loginUnknownError',
  },
  errors: {
    form: {
      bicFormat: 'errors.form.bicFormat',
      checked: 'errors.form.checked',
      different: 'errors.form.different',
      differentPassword: 'errors.form.differentPassword',
      email: 'errors.form.email',
      equal: 'errors.form.equal',
      ibanFormat: 'errors.form.ibanFormat',
      invalid: 'errors.form.invalid',
      maxLength: 'errors.form.maxLength',
      maxValue: 'errors.form.maxValue',
      minLength: 'errors.form.minLength',
      minValue: 'errors.form.minValue',
      newPassword: 'errors.form.newPassword',
      newPasswordConfirm: 'errors.form.newPasswordConfirm',
      noEmail: 'errors.form.noEmail',
      noPaste: 'errors.form.noPaste',
      password: 'errors.form.password',
      pattern: 'errors.form.pattern',
      phone: 'errors.form.phone',
      required: 'errors.form.required',
      voucherFormat: 'errors.form.voucherFormat',
      website: 'errors.form.website',
    },
    notFoundScreen: {
      cta: 'errors.notFoundScreen.cta',
      subTitle: 'errors.notFoundScreen.subTitle',
      title: 'errors.notFoundScreen.title',
    },
    server: {
      ACTION_UNAVAILABLE_IN_REGION:
        'errors.server.ACTION_UNAVAILABLE_IN_REGION',
      BUSINESS_SERVICE_ERROR: 'errors.server.BUSINESS_SERVICE_ERROR',
      CLIENT_NOT_AUTHENTICATED: 'errors.server.CLIENT_NOT_AUTHENTICATED',
      CONTACT_SUPPORT: 'errors.server.CONTACT_SUPPORT',
      CUSTOMER_ALREADY_HAS_EXTENDED_QUOTA:
        'errors.server.CUSTOMER_ALREADY_HAS_EXTENDED_QUOTA',
      DEFAULT: 'errors.server.DEFAULT',
      ENTITY_NOT_FOUND: 'errors.server.ENTITY_NOT_FOUND',
      EXTERNAL_SERVICE_ERROR: 'errors.server.EXTERNAL_SERVICE_ERROR',
      FORBIDDEN: 'errors.server.FORBIDDEN',
      FORBIDDEN_WRONG_REGION: 'errors.server.FORBIDDEN_WRONG_REGION',
      INTERNAL_SERVER_ERROR: 'errors.server.INTERNAL_SERVER_ERROR',
      INVALID_FILE_FORMAT: 'errors.server.INVALID_FILE_FORMAT',
      INVALID_REQUEST_SYNTAX: 'errors.server.INVALID_REQUEST_SYNTAX',
      KLARNA_ORDER_FAILED: 'errors.server.KLARNA_ORDER_FAILED',
      KLARNA_SESSION_FAILED: 'errors.server.KLARNA_SESSION_FAILED',
      NISS_ALREADY_HAS_EXTENDED_QUOTA_REQUEST:
        'errors.server.NISS_ALREADY_HAS_EXTENDED_QUOTA_REQUEST',
      NOT_ADULT_PROSPECT: 'errors.server.NOT_ADULT_PROSPECT',
      NO_VALID_CONTRACT: 'errors.server.NO_VALID_CONTRACT',
      QUOTA_EXCEEDED: 'errors.server.QUOTA_EXCEEDED',
      VALIDATION_EXCEPTION: 'errors.server.VALIDATION_EXCEPTION',
      VOUCHER_ORDER_FAILED: 'errors.server.VOUCHER_ORDER_FAILED',
      business: {
        FACEVALUE_BLOCKED_EXCHANGE:
          'errors.server.business.FACEVALUE_BLOCKED_EXCHANGE',
      },
      form: {
        CONTACT_SUPPORT: 'errors.server.form.CONTACT_SUPPORT',
        DATA_LIMIT_EXCEEDED: 'errors.server.form.DATA_LIMIT_EXCEEDED',
        DATE_IN_FUTURE: 'errors.server.form.DATE_IN_FUTURE',
        DEFAULT: 'errors.server.form.DEFAULT',
        INVALID: 'errors.server.form.INVALID',
        INVALID_FORMAT: 'errors.server.form.INVALID_FORMAT',
        MINIMUMAGENOTREACHED: 'errors.server.form.MINIMUMAGENOTREACHED',
        MINIMUM_AGE_NOT_REACHED: 'errors.server.form.MINIMUM_AGE_NOT_REACHED',
        MISSING_VALUE: 'errors.server.form.MISSING_VALUE',
        NISS_ALREADY_USED: 'errors.server.form.NISS_ALREADY_USED',
        NISS_MISMATCH: 'errors.server.form.NISS_MISMATCH',
        OUT_OF_ENUM: 'errors.server.form.OUT_OF_ENUM',
        POSTAL_CODE_IN_WRONG_REGION:
          'errors.server.form.POSTAL_CODE_IN_WRONG_REGION',
        START_DATE_GREATER_THAN_END_DATE:
          'errors.server.form.START_DATE_GREATER_THAN_END_DATE',
        UNKNOWN_VALUE: 'errors.server.form.UNKNOWN_VALUE',
        VALUE_ALREADY_EXISTS: 'errors.server.form.VALUE_ALREADY_EXISTS',
        VALUE_TOO_LONG: 'errors.server.form.VALUE_TOO_LONG',
        VALUE_TOO_SHORT: 'errors.server.form.VALUE_TOO_SHORT',
        nissAlreadyUsed: 'errors.server.form.nissAlreadyUsed',
        wrongRegion: 'errors.server.form.wrongRegion',
      },
      maintenance: {
        introText: 'errors.server.maintenance.introText',
        refreshButton: 'errors.server.maintenance.refreshButton',
        title: 'errors.server.maintenance.title',
      },
    },
    serviceUnavailableScreen: {
      cta: 'errors.serviceUnavailableScreen.cta',
      subTitle: 'errors.serviceUnavailableScreen.subTitle',
      title: 'errors.serviceUnavailableScreen.title',
    },
  },
  exchange: {
    alert: {
      brusselsPriceChangeWarning: {
        introText: 'exchange.alert.brusselsPriceChangeWarning.introText',
        linkText: 'exchange.alert.brusselsPriceChangeWarning.linkText',
        linkUrl: 'exchange.alert.brusselsPriceChangeWarning.linkUrl',
        title: 'exchange.alert.brusselsPriceChangeWarning.title',
      },
      success: {
        body: 'exchange.alert.success.body',
        title: 'exchange.alert.success.title',
      },
    },
    contractNumber: 'exchange.contractNumber',
    electronic: {
      expireDate: 'exchange.electronic.expireDate',
    },
    label: {
      newVoucherType: 'exchange.label.newVoucherType',
      paper: {
        voucherQuantity: 'exchange.label.paper.voucherQuantity',
        voucherTypeReceive: 'exchange.label.paper.voucherTypeReceive',
      },
      selectOrder: 'exchange.label.selectOrder',
      title: 'exchange.label.title',
      voucherType: 'exchange.label.voucherType',
    },
    paper: {
      confirmation: {
        cta: {
          getMyDocument: 'exchange.paper.confirmation.cta.getMyDocument',
        },
        fileName: 'exchange.paper.confirmation.fileName',
        infoTile: {
          message: 'exchange.paper.confirmation.infoTile.message',
          title: 'exchange.paper.confirmation.infoTile.title',
        },
        introduction: 'exchange.paper.confirmation.introduction',
        whatHappensNext: 'exchange.paper.confirmation.whatHappensNext',
      },
      howTo: {
        address: {
          city: 'exchange.paper.howTo.address.city',
          name: 'exchange.paper.howTo.address.name',
          street: 'exchange.paper.howTo.address.street',
        },
        cut: 'exchange.paper.howTo.cut',
        download: 'exchange.paper.howTo.download',
        print: 'exchange.paper.howTo.print',
        send: 'exchange.paper.howTo.send',
      },
    },
    radioLabel: {
      new: {
        electronic: 'exchange.radioLabel.new.electronic',
        paper: 'exchange.radioLabel.new.paper',
      },
      old: {
        electronic: 'exchange.radioLabel.old.electronic',
        noElectronic: 'exchange.radioLabel.old.noElectronic',
        paper: 'exchange.radioLabel.old.paper',
      },
    },
    remarks: {
      electronic: 'exchange.remarks.electronic',
      mobile: {
        downloadLink: 'exchange.remarks.mobile.downloadLink',
        electronic: 'exchange.remarks.mobile.electronic',
        title: 'exchange.remarks.mobile.title',
      },
    },
    subtitle: 'exchange.subtitle',
    summary: {
      expirationDate: 'exchange.summary.expirationDate',
      faceValue: 'exchange.summary.faceValue',
      fullName: 'exchange.summary.fullName',
      previousExpirationDate: 'exchange.summary.previousExpirationDate',
      purchaseId: 'exchange.summary.purchaseId',
      quantity: 'exchange.summary.quantity',
      title: 'exchange.summary.title',
    },
    table: {
      date: 'exchange.table.date',
      reference: 'exchange.table.reference',
      total: 'exchange.table.total',
      vouchersQuantity: 'exchange.table.vouchersQuantity',
    },
    title: 'exchange.title',
  },
  fiscalAttestation: {
    disclaimer: {
      content: 'fiscalAttestation.disclaimer.content',
      title: 'fiscalAttestation.disclaimer.title',
    },
    download: {
      document: 'fiscalAttestation.download.document',
      title: 'fiscalAttestation.download.title',
    },
    exercice: {
      codes: 'fiscalAttestation.exercice.codes',
      info: 'fiscalAttestation.exercice.info',
      infoNotApplicable: 'fiscalAttestation.exercice.infoNotApplicable',
      infoNotReady: 'fiscalAttestation.exercice.infoNotReady',
      title: 'fiscalAttestation.exercice.title',
    },
    history: {
      introduction: 'fiscalAttestation.history.introduction',
      title: 'fiscalAttestation.history.title',
    },
    info: 'fiscalAttestation.info',
    introduction: 'fiscalAttestation.introduction',
    taxonweb: 'fiscalAttestation.taxonweb',
  },
  footer: {
    copyright: 'footer.copyright',
    cta: {
      complaint: {
        label: 'footer.cta.complaint.label',
        url: 'footer.cta.complaint.url',
      },
      question: {
        label: 'footer.cta.question.label',
        url: 'footer.cta.question.url',
      },
    },
    foremLogoAlt: 'footer.foremLogoAlt',
    nav: {
      cookies: {
        label: 'footer.nav.cookies.label',
      },
      news: {
        label: 'footer.nav.news.label',
        url: 'footer.nav.news.url',
      },
      pp: {
        label: 'footer.nav.pp.label',
      },
      tc: {
        label: 'footer.nav.tc.label',
        url: 'footer.nav.tc.url',
      },
    },
    subtitle: 'footer.subtitle',
    title: 'footer.title',
  },
  forms: {
    requiredLegend: 'forms.requiredLegend',
  },
  forbiddenWrongRegion: {
    introduction: 'forbiddenWrongRegion.introduction',
    mobile: {
      errorNoStoreAvailable:
        'forbiddenWrongRegion.mobile.errorNoStoreAvailable',
      introduction: 'forbiddenWrongRegion.mobile.introduction',
      title: 'forbiddenWrongRegion.mobile.title',
    },
    title: 'forbiddenWrongRegion.title',
  },
  general: {
    activeTabLabel: 'general.activeTabLabel',
    and: 'general.and',
    appTitle: 'general.appTitle',
    attention: 'general.attention',
    autoCompletedataLoading: 'general.autoCompletedataLoading',
    breadcrumbLabel: 'general.breadcrumbLabel',
    close: 'general.close',
    contractType: {
      MATERNITY: 'general.contractType.MATERNITY',
      STANDARD: 'general.contractType.STANDARD',
    },
    cta: {
      cancel: 'general.cta.cancel',
      delete: 'general.cta.delete',
      details: 'general.cta.details',
      download: 'general.cta.download',
      edit: 'general.cta.edit',
      exchange: 'general.cta.exchange',
      ok: 'general.cta.ok',
      order: 'general.cta.order',
      previous: 'general.cta.previous',
      refund: 'general.cta.refund',
      retry: 'general.cta.retry',
      save: 'general.cta.save',
      validate: 'general.cta.validate',
    },
    datePicker: {
      addonText: 'general.datePicker.addonText',
      addonTooltip: 'general.datePicker.addonTooltip',
    },
    daysCount: 'general.daysCount',
    errors: {
      form: {
        autocomplete: {
          minLength: 'general.errors.form.autocomplete.minLength',
        },
        invalidStreet: 'general.errors.form.invalidStreet',
      },
    },
    first: 'general.first',
    form: {
      errorMessage: 'general.form.errorMessage',
      validationErrorMessage: 'general.form.validationErrorMessage',
    },
    hidePassword: 'general.hidePassword',
    keyword: 'general.keyword',
    label: {
      amount: 'general.label.amount',
      bankAccount: 'general.label.bankAccount',
      beneficiaryIban: 'general.label.beneficiaryIban',
      bic: 'general.label.bic',
      city: 'general.label.city',
      contractType: 'general.label.contractType',
      dateFormat: 'general.label.dateFormat',
      emailAddress: 'general.label.emailAddress',
      firstName: 'general.label.firstName',
      iban: 'general.label.iban',
      itIsMyDeliveryAddress: 'general.label.itIsMyDeliveryAddress',
      mobilePhoneNumber: 'general.label.mobilePhoneNumber',
      name: 'general.label.name',
      niss: 'general.label.niss',
      number: 'general.label.number',
      paymentDate: 'general.label.paymentDate',
      paymentMethod: 'general.label.paymentMethod',
      paymentType: {
        bankTransfer: 'general.label.paymentType.bankTransfer',
        klarna: 'general.label.paymentType.klarna',
      },
      phoneNumber: 'general.label.phoneNumber',
      postcode: 'general.label.postcode',
      product: 'general.label.product',
      quantity: 'general.label.quantity',
      street: 'general.label.street',
      title: 'general.label.title',
      total: 'general.label.total',
      voucherType: 'general.label.voucherType',
    },
    language: {
      DE: 'general.language.DE',
      FR: 'general.language.FR',
      NL: 'general.language.NL',
    },
    last: 'general.last',
    mainAddress: 'general.mainAddress',
    mobile: {
      update: {
        body: {
          mandatory: 'general.mobile.update.body.mandatory',
          optional: 'general.mobile.update.body.optional',
        },
        cta: {
          continue: 'general.mobile.update.cta.continue',
          update: 'general.mobile.update.cta.update',
        },
        title: 'general.mobile.update.title',
      },
    },
    mobilePermissions: {
      externalStorage: {
        message: 'general.mobilePermissions.externalStorage.message',
        title: 'general.mobilePermissions.externalStorage.title',
      },
    },
    monthCount: 'general.monthCount',
    navigation: 'general.navigation',
    next: 'general.next',
    noResults: 'general.noResults',
    notYetDefined: 'general.notYetDefined',
    optionPlaceholder: 'general.optionPlaceholder',
    selectPlaceholder: {
      language: 'general.selectPlaceholder.language',
      title: 'general.selectPlaceholder.title',
    },
    or: 'general.or',
    page: 'general.page',
    pageLoading: 'general.pageLoading',
    pager: {
      of: 'general.pager.of',
    },
    paymentMethod: {
      BANCONTACT: 'general.paymentMethod.BANCONTACT',
      BANK_TRANSFER: 'general.paymentMethod.BANK_TRANSFER',
      INSTANT_PAYMENT: 'general.paymentMethod.INSTANT_PAYMENT',
      MASTERCARD: 'general.paymentMethod.MASTERCARD',
      ONLINE_PAYMENT: 'general.paymentMethod.ONLINE_PAYMENT',
      VISA: 'general.paymentMethod.VISA',
    },
    personalDetails: 'general.personalDetails',
    previous: 'general.previous',
    search: 'general.search',
    showPassword: 'general.showPassword',
    statusType: {
      DEFAULT: 'general.statusType.DEFAULT',
      PAID: 'general.statusType.PAID',
      PENDING: 'general.statusType.PENDING',
      PROCESSING: 'general.statusType.PROCESSING',
      RECEIVED: 'general.statusType.RECEIVED',
      SENT: 'general.statusType.SENT',
    },
    supportType: {
      ELECTRONIC: 'general.supportType.ELECTRONIC',
      PAPER: 'general.supportType.PAPER',
    },
    title: {
      MR: 'general.title.MR',
      MRS: 'general.title.MRS',
    },
    upload: {
      error: 'general.upload.error',
      label: 'general.upload.label',
      labelDrag: 'general.upload.labelDrag',
      remove: 'general.upload.remove',
      removeAll: 'general.upload.removeAll',
    },
    voucher: 'general.voucher',
    vouchersCount: 'general.vouchersCount',
  },
  handiweb: {
    explaination: 'handiweb.explaination',
    form: {
      alert: {
        error: {
          message: 'handiweb.form.alert.error.message',
          title: 'handiweb.form.alert.error.title',
        },
        success: {
          message: 'handiweb.form.alert.success.message',
          title: 'handiweb.form.alert.success.title',
        },
      },
      introduction: 'handiweb.form.introduction',
      labels: {
        other: 'handiweb.form.labels.other',
      },
      optin: 'handiweb.form.optin',
      requestTarget: {
        label: {
          dependent: 'handiweb.form.requestTarget.label.dependent',
        },
        labels: {
          myself: 'handiweb.form.requestTarget.labels.myself',
        },
        legend: 'handiweb.form.requestTarget.legend',
      },
    },
    introduction: 'handiweb.introduction',
    title: 'handiweb.title',
  },
  header: {
    appNameTitle: 'header.appNameTitle',
    appNameTitleWithRegion: 'header.appNameTitleWithRegion',
    funcHeader: {
      cta: {
        backToInfoWebsite: {
          title: 'header.funcHeader.cta.backToInfoWebsite.title',
        },
      },
    },
    redirectToRegionHomePage: 'header.redirectToRegionHomePage',
    support: {
      contactList: {
        callus: {
          title: 'header.support.contactList.callus.title',
        },
        contactus: {
          description: 'header.support.contactList.contactus.description',
          link: 'header.support.contactList.contactus.link',
          link_copy: 'header.support.contactList.contactus.link_copy',
          title: 'header.support.contactList.contactus.title',
        },
        description: 'header.support.contactList.description',
        findProvider: {
          description: 'header.support.contactList.findProvider.description',
          link: 'header.support.contactList.findProvider.link',
          title: 'header.support.contactList.findProvider.title',
        },
        helpCenter: {
          description: 'header.support.contactList.helpCenter.description',
          link: 'header.support.contactList.helpCenter.link',
          title: 'header.support.contactList.helpCenter.title',
        },
        pass: {
          description: 'header.support.contactList.pass.description',
          title: 'header.support.contactList.pass.title',
        },
        title: 'header.support.contactList.title',
      },
      subtitle: 'header.support.subtitle',
      title: 'header.support.title',
    },
  },
  landing: {
    cards: {
      signin: {
        cta: 'landing.cards.signin.cta',
        description: 'landing.cards.signin.description',
        title: 'landing.cards.signin.title',
        tooltip: 'landing.cards.signin.tooltip',
      },
      signup: {
        cta: 'landing.cards.signup.cta',
        description: 'landing.cards.signup.description',
        title: 'landing.cards.signup.title',
      },
    },
    issues: {
      description: 'landing.issues.description',
      mobile: {
        line1: 'landing.issues.mobile.line1',
        line2: 'landing.issues.mobile.line2',
        phone: 'landing.issues.mobile.phone',
      },
    },
    issuesPhone: 'landing.issuesPhone',
    title: 'landing.title',
  },
  languageRequest: {
    alert: {
      list: {
        item: {
          printed: 'languageRequest.alert.list.item.printed',
          serviceAccount: 'languageRequest.alert.list.item.serviceAccount',
          serviceCommunication:
            'languageRequest.alert.list.item.serviceCommunication',
          taxCertificate: 'languageRequest.alert.list.item.taxCertificate',
        },
      },
      title: 'languageRequest.alert.title',
    },
    cta: {
      changeLanguageToFrench: 'languageRequest.cta.changeLanguageToFrench',
    },
    introduction: 'languageRequest.introduction',
    message: {
      error: {
        alreadyRequested: 'languageRequest.message.error.alreadyRequested',
        notAllowed: 'languageRequest.message.error.notAllowed',
      },
      success: 'languageRequest.message.success',
    },
    title: 'languageRequest.title',
  },
  languageSwitcher: {
    title: 'languageSwitcher.title',
  },
  login: {
    labels: {
      usefullLinks: {
        cantConnect: 'login.labels.usefullLinks.cantConnect',
        cookies: 'login.labels.usefullLinks.cookies',
        howTo: 'login.labels.usefullLinks.howTo',
        title: 'login.labels.usefullLinks.title',
      },
    },
  },
  navigation: {
    account: 'navigation.account',
    backServiceVouchersLogin: 'navigation.backServiceVouchersLogin',
    backToDashboard: 'navigation.backToDashboard',
    backToHomepage: 'navigation.backToHomepage',
    blocked: 'navigation.blocked',
    contactUs: 'navigation.contactUs',
    cookies: 'navigation.cookies',
    dashboard: 'navigation.dashboard',
    error404: 'navigation.error404',
    faq: 'navigation.faq',
    findProvider: 'navigation.findProvider',
    fiscalAttestation: 'navigation.fiscalAttestation',
    handiwebRequest: 'navigation.handiwebRequest',
    landing: 'navigation.landing',
    languageRequest: 'navigation.languageRequest',
    login: 'navigation.login',
    logout: 'navigation.logout',
    maintenance: 'navigation.maintenance',
    myInfos: 'navigation.myInfos',
    news: 'navigation.news',
    orderDetails: 'navigation.orderDetails',
    orders: 'navigation.orders',
    other: 'navigation.other',
    planALeave: 'navigation.planALeave',
    preferences: 'navigation.preferences',
    prestations: 'navigation.prestations',
    profile: 'navigation.profile',
    register: 'navigation.register',
    registerComplete: 'navigation.registerComplete',
    registerSummary: 'navigation.registerSummary',
    reglementation: 'navigation.reglementation',
    serviceUnavailable: 'navigation.serviceUnavailable',
    serviceVouchers: 'navigation.serviceVouchers',
    serviceVouchersLogin: 'navigation.serviceVouchersLogin',
    services: 'navigation.services',
    support: 'navigation.support',
    tac: 'navigation.tac',
    title: 'navigation.title',
    wallet: 'navigation.wallet',
    worksHistory: 'navigation.worksHistory',
    worksManagement: 'navigation.worksManagement',
    wrongRegion: 'navigation.wrongRegion',
  },
  newOrder: {
    noQuota: 'newOrder.noQuota',
    step: {
      details: 'newOrder.step.details',
      order: 'newOrder.step.order',
      payment: 'newOrder.step.payment',
    },
    stepConfirmation: {
      accountOwner: {
        details: 'newOrder.stepConfirmation.accountOwner.details',
        title: 'newOrder.stepConfirmation.accountOwner.title',
      },
      alert: {
        body: 'newOrder.stepConfirmation.alert.body',
        title: 'newOrder.stepConfirmation.alert.title',
      },
      amountToPay: 'newOrder.stepConfirmation.amountToPay',
      communication: 'newOrder.stepConfirmation.communication',
      cta: {
        back: 'newOrder.stepConfirmation.cta.back',
      },
      description: 'newOrder.stepConfirmation.description',
      paymentInfo: 'newOrder.stepConfirmation.paymentInfo',
      qrCodeAlert: {
        body: 'newOrder.stepConfirmation.qrCodeAlert.body',
        title: 'newOrder.stepConfirmation.qrCodeAlert.title',
      },
      title: 'newOrder.stepConfirmation.title',
    },
    stepDetails: {
      alert: {
        body: 'newOrder.stepDetails.alert.body',
        title: 'newOrder.stepDetails.alert.title',
      },
      deliveryAddress: 'newOrder.stepDetails.deliveryAddress',
      mainAddress: 'newOrder.stepDetails.mainAddress',
      personalDetails: 'newOrder.stepDetails.personalDetails',
    },
    stepOrder: {
      alert: 'newOrder.stepOrder.alert',
      cta: {
        selectOtherType: 'newOrder.stepOrder.cta.selectOtherType',
      },
      form: {
        tableFooter: {
          legend: 'newOrder.stepOrder.form.tableFooter.legend',
        },
        tableHeader: {
          quantity: 'newOrder.stepOrder.form.tableHeader.quantity',
          value: 'newOrder.stepOrder.form.tableHeader.value',
        },
        tableRow: {
          vouchers: 'newOrder.stepOrder.form.tableRow.vouchers',
        },
        voucherAmount: {
          label: 'newOrder.stepOrder.form.voucherAmount.label',
        },
        formatSelector: {
          flanders: {
            description:
              'newOrder.stepOrder.form.formatSelector.flanders.description',
          },
        },
      },
      label: {
        adaptVoucherType: 'newOrder.stepOrder.label.adaptVoucherType',
      },
    },
    stepPayment: {
      OrderSummary: 'newOrder.stepPayment.OrderSummary',
      alert: {
        pendingOrderAlreadyExists: {
          body: 'newOrder.stepPayment.alert.pendingOrderAlreadyExists.body',
        },
      },
      cta: {
        buy: 'newOrder.stepPayment.cta.buy',
        submit: 'newOrder.stepPayment.cta.submit',
      },
      directPayment: {
        general: {
          error: 'newOrder.stepPayment.directPayment.general.error',
        },
        noQuota: 'newOrder.stepPayment.directPayment.noQuota',
        orderDeclined: 'newOrder.stepPayment.directPayment.orderDeclined',
        paidWithNoVoucher:
          'newOrder.stepPayment.directPayment.paidWithNoVoucher',
      },
      klarna: {
        confirmationOrder: {
          cta: 'newOrder.stepPayment.klarna.confirmationOrder.cta',
          description:
            'newOrder.stepPayment.klarna.confirmationOrder.description',
          title: 'newOrder.stepPayment.klarna.confirmationOrder.title',
        },
        confirmationPayment: {
          alertMessage:
            'newOrder.stepPayment.klarna.confirmationPayment.alertMessage',
          alertPaperMessage:
            'newOrder.stepPayment.klarna.confirmationPayment.alertPaperMessage',
          cta: 'newOrder.stepPayment.klarna.confirmationPayment.cta',
          title: 'newOrder.stepPayment.klarna.confirmationPayment.title',
        },
        cta: 'newOrder.stepPayment.klarna.cta',
        info: 'newOrder.stepPayment.klarna.info',
        infoBanks: 'newOrder.stepPayment.klarna.infoBanks',
        loading: 'newOrder.stepPayment.klarna.loading',
        processingOrder: 'newOrder.stepPayment.klarna.processingOrder',
      },
      termsConditionsKlarna: 'newOrder.stepPayment.termsConditionsKlarna',
    },
    title: 'newOrder.title',
  },
  onboarding: {
    account: {
      modalOne: {
        description: 'onboarding.account.modalOne.description',
        mobileDescription: 'onboarding.account.modalOne.mobileDescription',
        subtitle: 'onboarding.account.modalOne.subtitle',
        title: 'onboarding.account.modalOne.title',
      },
    },
    dashboard: {
      modalOne: {
        description: 'onboarding.dashboard.modalOne.description',
        subtitle: 'onboarding.dashboard.modalOne.subtitle',
        title: 'onboarding.dashboard.modalOne.title',
      },
      modalThree: {
        description: 'onboarding.dashboard.modalThree.description',
        subtitle: 'onboarding.dashboard.modalThree.subtitle',
        title: 'onboarding.dashboard.modalThree.title',
      },
      modalTwo: {
        description: 'onboarding.dashboard.modalTwo.description',
        subtitle: 'onboarding.dashboard.modalTwo.subtitle',
        title: 'onboarding.dashboard.modalTwo.title',
      },
    },
    serviceVouchers: {
      modalOne: {
        description: {
          otherRegion:
            'onboarding.serviceVouchers.modalOne.description.otherRegion',
          vl: 'onboarding.serviceVouchers.modalOne.description.vl',
        },
        subtitle: 'onboarding.serviceVouchers.modalOne.subtitle',
        title: 'onboarding.serviceVouchers.modalOne.title',
      },
      modalTwo: {
        description: 'onboarding.serviceVouchers.modalTwo.description',
        subtitle: 'onboarding.serviceVouchers.modalTwo.subtitle',
        title: 'onboarding.serviceVouchers.modalTwo.title',
      },
    },
    workManagement: {
      modalOne: {
        description: 'onboarding.workManagement.modalOne.description',
        subtitle: 'onboarding.workManagement.modalOne.subtitle',
        title: 'onboarding.workManagement.modalOne.title',
      },
      modalTwo: {
        description: 'onboarding.workManagement.modalTwo.description',
        subtitle: 'onboarding.workManagement.modalTwo.subtitle',
        title: 'onboarding.workManagement.modalTwo.title',
      },
    },
  },
  orders: {
    alert: {
      availableVouchers: 'orders.alert.availableVouchers',
      noOrderContent: 'orders.alert.noOrderContent',
      noOrderTitle: 'orders.alert.noOrderTitle',
      subTitle: 'orders.alert.subTitle',
    },
    cell: {
      paymentPending: 'orders.cell.paymentPending',
      paymentReceivedOn: 'orders.cell.paymentReceivedOn',
      processingOrder: 'orders.cell.processingOrder',
      vouchersReceivedOn: 'orders.cell.vouchersReceivedOn',
      vouchersSentOn: 'orders.cell.vouchersSentOn',
    },
    details: {
      electronic: {
        pendingOrDone: {
          alert: {
            subTitle: 'orders.details.electronic.pendingOrDone.alert.subTitle',
          },
        },
      },
      orderRefTitle: 'orders.details.orderRefTitle',
      paper: {
        done: {
          alert: {
            subTitle: 'orders.details.paper.done.alert.subTitle',
          },
        },
        inProgress: {
          alert: {
            subTitle: 'orders.details.paper.inProgress.alert.subTitle',
          },
        },
      },
      pending: {
        alert: {
          subTitle: 'orders.details.pending.alert.subTitle',
        },
      },
      pendingTitle: 'orders.details.pendingTitle',
      purchaseTitle: 'orders.details.purchaseTitle',
      quantity: 'orders.details.quantity',
      sendDateTitle: 'orders.details.sendDateTitle',
      steps: {
        button: 'orders.details.steps.button',
        labels: {
          PAID: 'orders.details.steps.labels.PAID',
          PAID_PROCESSING: 'orders.details.steps.labels.PAID_PROCESSING',
          PENDING: 'orders.details.steps.labels.PENDING',
          PROCESSING: 'orders.details.steps.labels.PROCESSING',
          RECEIVED: 'orders.details.steps.labels.RECEIVED',
          SENT: 'orders.details.steps.labels.SENT',
          SENT_RECEIVED: 'orders.details.steps.labels.SENT_RECEIVED',
        },
        titles: {
          PAID: 'orders.details.steps.titles.PAID',
          PAID_PROCESSING: 'orders.details.steps.titles.PAID_PROCESSING',
          PENDING: 'orders.details.steps.titles.PENDING',
          PROCESSING: 'orders.details.steps.titles.PROCESSING',
          RECEIVED: 'orders.details.steps.titles.RECEIVED',
          SENT: 'orders.details.steps.titles.SENT',
          SENT_RECEIVED: 'orders.details.steps.titles.SENT_RECEIVED',
        },
      },
      subtitle: 'orders.details.subtitle',
    },
    introduction: 'orders.introduction',
    noOrders: 'orders.noOrders',
    subtitle: 'orders.subtitle',
    table: {
      status: 'orders.table.status',
      vouchers: 'orders.table.vouchers',
    },
  },
  pageTitle: {
    general: 'pageTitle.general',
  },
  planALeave: {
    absentFrom: 'planALeave.absentFrom',
    alert: {
      body: 'planALeave.alert.body',
      error: 'planALeave.alert.error',
      title: 'planALeave.alert.title',
    },
    form: {
      error: {
        range: 'planALeave.form.error.range',
        title: 'planALeave.form.error.title',
      },
    },
    from: 'planALeave.from',
    iWantToSuspend: 'planALeave.iWantToSuspend',
    included: 'planALeave.included',
    infoTile: {
      body: {
        currentYear: 'planALeave.infoTile.body.currentYear',
        nextYear: 'planALeave.infoTile.body.nextYear',
        noDayAvailable: 'planALeave.infoTile.body.noDayAvailable',
        noDayAvailableNextYear:
          'planALeave.infoTile.body.noDayAvailableNextYear',
      },
      title: 'planALeave.infoTile.title',
    },
    introduction: 'planALeave.introduction',
    myAbsences: 'planALeave.myAbsences',
    noContent: {
      body: 'planALeave.noContent.body',
      title: 'planALeave.noContent.title',
    },
    noVacanciesContent: 'planALeave.noVacanciesContent',
    noVacanciesTitle: 'planALeave.noVacanciesTitle',
    numberOfDays: 'planALeave.numberOfDays',
    ofAbsence: 'planALeave.ofAbsence',
    table: {
      dates: 'planALeave.table.dates',
      duration: 'planALeave.table.duration',
      tooltip: {
        twoYearsInRaw: 'planALeave.table.tooltip.twoYearsInRaw',
      },
    },
    to: 'planALeave.to',
  },
  preference: {
    displayLanguage: {
      cta: 'preference.displayLanguage.cta',
      label: 'preference.displayLanguage.label',
    },
    emailNeeded: {
      info: 'preference.emailNeeded.info',
    },
    introduction: 'preference.introduction',
    success: {
      electronic: 'preference.success.electronic',
      paper: 'preference.success.paper',
    },
    voucherFormat: 'preference.voucherFormat',
    voucherManagement: 'preference.voucherManagement',
  },
  profile: {
    accountName: 'profile.accountName',
    bankDetails: {
      title: 'profile.bankDetails.title',
    },
    boxNumber: 'profile.boxNumber',
    changeEmailModal: {
      oldEmailAddress: 'profile.changeEmailModal.oldEmailAddress',
      title: 'profile.changeEmailModal.title',
    },
    changePassword: 'profile.changePassword',
    changePasswordModal: {
      description: 'profile.changePasswordModal.description',
      passwordRules: 'profile.changePasswordModal.passwordRules',
      title: 'profile.changePasswordModal.title',
    },
    changeRegionModal: {
      cta: {
        cancel: 'profile.changeRegionModal.cta.cancel',
        confirm: 'profile.changeRegionModal.cta.confirm',
      },
      disclaimer: 'profile.changeRegionModal.disclaimer',
      title: 'profile.changeRegionModal.title',
    },
    communicationLanguage: 'profile.communicationLanguage',
    confirmNewPassword: 'profile.confirmNewPassword',
    contactMe: {
      changeEmailInfo: {
        subtitle: 'profile.contactMe.changeEmailInfo.subtitle',
        title: 'profile.contactMe.changeEmailInfo.title',
      },
      title: 'profile.contactMe.title',
      beforeJune17: 'profile.contactMe.migrationInfo.beforeJune17',
      afterJune17: {
        text: 'profile.contactMe.migrationInfo.afterJune17',
        button: 'profile.contactMe.migrationInfo.afterJune17.button',
        url: 'profile.contactMe.migrationInfo.afterJune17.url',
      },
    },
    contractList: {
      goProfile: 'profile.contractList.goProfile',
      profileID: 'profile.contractList.profileID',
      profileMaternityID: 'profile.contractList.profileMaternityID',
      subtitle: 'profile.contractList.subtitle',
      title: 'profile.contractList.title',
    },
    currentPassword: 'profile.currentPassword',
    customerSection: {
      title: 'profile.customerSection.title',
    },
    dateOfBirth: 'profile.dateOfBirth',
    deliveryAddress: {
      title: 'profile.deliveryAddress.title',
    },
    emailAddressConfirmation: 'profile.emailAddressConfirmation',
    error: {
      city: {
        required: 'profile.error.city.required',
      },
      confirmEmailAddress: {
        required: 'profile.error.confirmEmailAddress.required',
      },
      confirmNewPassword: {
        required: 'profile.error.confirmNewPassword.required',
      },
      deliveryAddress: {
        houseNumber: {
          required: 'profile.error.deliveryAddress.houseNumber.required',
        },
        postcode: {
          required: 'profile.error.deliveryAddress.postcode.required',
        },
        street: {
          required: 'profile.error.deliveryAddress.street.required',
        },
      },
      emailAddress: {
        required: 'profile.error.emailAddress.required',
      },
      houseNumber: {
        required: 'profile.error.houseNumber.required',
      },
      mainAddress: {
        houseNumber: {
          required: 'profile.error.mainAddress.houseNumber.required',
        },
        postcode: {
          required: 'profile.error.mainAddress.postcode.required',
        },
        street: {
          required: 'profile.error.mainAddress.street.required',
        },
      },
      newPassword: {
        required: 'profile.error.newPassword.required',
      },
      notPasted: 'profile.error.notPasted',
      oldPassword: {
        required: 'profile.error.oldPassword.required',
      },
      postcode: {
        required: 'profile.error.postcode.required',
      },
      street: {
        required: 'profile.error.street.required',
      },
    },
    errorMessage: 'profile.errorMessage',
    errors: {
      form: {
        eidStreetNotFound: 'profile.errors.form.eidStreetNotFound',
      },
    },
    forgotPassword: 'profile.forgotPassword',
    goToMandateProfile: 'profile.goToMandateProfile',
    inactiveNonUsage: {
      title: 'profile.inactiveNonUsage.title',
      intro: 'profile.inactiveNonUsage.intro',
      updateViaEid: 'profile.inactiveNonUsage.updateViaEid',
      confirmCorrect: 'profile.inactiveNonUsage.confirmCorrect',
      outro: 'profile.inactiveNonUsage.outro',
      confirmCheckbox: 'profile.inactiveNonUsage.confirmCheckbox',
    },
    infoFromEidReader: 'profile.infoFromEidReader',
    introduction: 'profile.introduction',
    loggedAs: {
      title: 'profile.loggedAs.title',
    },
    loginSection: {
      title: 'profile.loginSection.title',
    },
    mainAddress: {
      title: 'profile.mainAddress.title',
    },
    manageAccountOf: {
      title: 'profile.manageAccountOf.title',
    },
    mobilePhoneNumber: 'profile.mobilePhoneNumber',
    nationalNumber: 'profile.nationalNumber',
    newPassword: 'profile.newPassword',
    notFoundAddresContactInformation:
      'profile.notFoundAddresContactInformation',
    notFoundAddress: {
      introduction: 'profile.notFoundAddress.introduction',
      title: 'profile.notFoundAddress.title',
    },
    otherManagedAccounts: {
      title: 'profile.otherManagedAccounts.title',
    },
    personalInformation: {
      description: 'profile.personalInformation.description',
      subTitle: 'profile.personalInformation.subTitle',
      title: 'profile.personalInformation.title',
    },
    phoneNumber: 'profile.phoneNumber',
    requestMandate: 'profile.requestMandate',
    successMessage: 'profile.successMessage',
    updateEmailAddress: {
      introduction: 'profile.updateEmailAddress.introduction',
      title: 'profile.updateEmailAddress.title',
    },
    updatePassword: {
      introduction: 'profile.updatePassword.introduction',
      title: 'profile.updatePassword.title',
    },
    updatePersonalInformation: {
      introduction: 'profile.updatePersonalInformation.introduction',
      title: 'profile.updatePersonalInformation.title',
    },
    useEmailAsContactEmail: 'profile.useEmailAsContactEmail',
  },
  profileSwitcher: {
    activeAccount: 'profileSwitcher.activeAccount',
    id: 'profileSwitcher.id',
    otherAccounts: 'profileSwitcher.otherAccounts',
    title: 'profileSwitcher.title',
  },
  refund: {
    cta: {
      selectPreviousAccount: 'refund.cta.selectPreviousAccount',
      useAnotherAccount: 'refund.cta.useAnotherAccount',
    },
    intro: {
      end: 'refund.intro.end',
      start: 'refund.intro.start',
    },
    introduction: {
      end: 'refund.introduction.end',
      start: 'refund.introduction.start',
    },
    noVouchersValueCount: 'refund.noVouchersValueCount',
    numberOfVouchers: 'refund.numberOfVouchers',
    numberOfVouchersOfPrice: 'refund.numberOfVouchersOfPrice',
    paper: {
      confirmation: {
        cta: {
          getMyDocument: 'refund.paper.confirmation.cta.getMyDocument',
        },
        fileName: 'refund.paper.confirmation.fileName',
        infoTile: {
          message: 'refund.paper.confirmation.infoTile.message',
          title: 'refund.paper.confirmation.infoTile.title',
        },
        instructions: {
          address: {
            city: 'refund.paper.confirmation.instructions.address.city',
            name: 'refund.paper.confirmation.instructions.address.name',
            street: 'refund.paper.confirmation.instructions.address.street',
          },
          cut: 'refund.paper.confirmation.instructions.cut',
          download: 'refund.paper.confirmation.instructions.download',
          print: 'refund.paper.confirmation.instructions.print',
          send: 'refund.paper.confirmation.instructions.send',
        },
        introduction: 'refund.paper.confirmation.introduction',
        whatHappensNext: 'refund.paper.confirmation.whatHappensNext',
      },
      disclaimer: 'refund.paper.disclaimer',
      howTo: {
        address: {
          city: 'refund.paper.howTo.address.city',
          name: 'refund.paper.howTo.address.name',
          street: 'refund.paper.howTo.address.street',
        },
        cut: 'refund.paper.howTo.cut',
        download: 'refund.paper.howTo.download',
        print: 'refund.paper.howTo.print',
        send: 'refund.paper.howTo.send',
      },
      readAndApproved: 'refund.paper.readAndApproved',
    },
    success: {
      alert: {
        body: 'refund.success.alert.body',
        title: 'refund.success.alert.title',
      },
      confirmationText: 'refund.success.confirmationText',
      cta: {
        backToWallet: 'refund.success.cta.backToWallet',
      },
      title: 'refund.success.title',
    },
    summary: {
      disclaimer: 'refund.summary.disclaimer',
      title: 'refund.summary.title',
    },
    title: 'refund.title',
    vouchersValueCount: 'refund.vouchersValueCount',
  },
  register: {
    alert: {
      list: {
        minEighteenYearOld: 'register.alert.list.minEighteenYearOld',
        onlyBelgium: 'register.alert.list.onlyBelgium',
      },
      title: 'register.alert.title',
    },
    cta: {
      eid: 'register.cta.eid',
      manually: 'register.cta.manually',
      sendRequest: 'register.cta.sendRequest',
    },
    eid: {
      info: 'register.eid.info',
      title: 'register.eid.title',
    },
    errors: {
      form: {
        birthDateRequired: 'register.errors.form.birthDateRequired',
        deliveryAddressCityRequired: 'register.errors.form.deliveryAddressCityRequired',
        deliveryAddressHouseNumberRequired: 'register.errors.form.deliveryAddressHouseNumberRequired',
        deliveryAddressPostcodeRequired: 'register.errors.form.deliveryAddressPostcodeRequired',
        deliveryAddressStreetRequired: 'register.errors.form.deliveryAddressStreetRequired',
        eidStreetNotFound: 'register.errors.form.eidStreetNotFound',
        emailAddressRequired: 'register.errors.form.emailAddressRequired',
        firstNameRequired: 'register.errors.form.firstNameRequired',
        languageRequired: 'register.errors.form.languageRequired',
        lastNameRequired: 'register.errors.form.lastNameRequired',
        mainAddressCityRequired: 'register.errors.form.mainAddressCityRequired',
        mainAddressHouseNumberRequired: 'register.errors.form.mainAddressHouseNumberRequired',
        mainAddressPostcodeRequired: 'register.errors.form.mainAddressPostcodeRequired',
        mainAddressStreetRequired: 'register.errors.form.mainAddressStreetRequired',
        minEighteenYearOld: 'register.errors.form.minEighteenYearOld',
        nissRequired: 'register.errors.form.nissRequired',
        preferredSupportTypeRequired: 'register.errors.form.preferredSupportTypeRequired',
        refundBankAccountRequired: 'register.errors.form.refundBankAccountRequired',
        titleRequired: 'register.errors.form.titleRequired',
        wrongRegion: 'register.errors.form.wrongRegion',
      },
    },
    form: {
      bankAccount: {
        label: 'register.form.bankAccount.label',
      },
      supportType: {
        label: 'register.form.supportType.label',
      },
    },
    formSection: {
      bankAccount: {
        description: 'register.formSection.bankAccount.description',
        title: 'register.formSection.bankAccount.title',
      },
      contact: {
        title: 'register.formSection.contact.title',
      },
      preference: {
        title: 'register.formSection.preference.title',
      },
    },
    introduction: 'register.introduction',
    manually: {
      title: 'register.manually.title',
    },
    mbpRedirect: {
      info: 'register.mbpRedirect.info',
      linkText: 'register.mbpRedirect.linkText',
      linkUrl: 'register.mbpRedirect.linkUrl',
    },
    step1: {
      TAC: {
        link: {
          label: {
            conditions: 'register.step1.TAC.link.label.conditions',
            privacy: 'register.step1.TAC.link.label.privacy',
          },
        },
        text: 'register.step1.TAC.text',
        textEnd: 'register.step1.TAC.textEnd',
      },
      introduction: 'register.step1.introduction',
    },
    step2: {
      introduction: 'register.step2.introduction',
    },
    summary: {
      alert: {
        content: 'register.summary.alert.content',
        title: 'register.summary.alert.title',
      },
      title: 'register.summary.title',
    },
    summarySection: {
      contact: {
        title: 'register.summarySection.contact.title',
      },
      preference: {
        title: 'register.summarySection.preference.title',
      },
    },
    title: 'register.title',
  },
  splashScreen: {
    alert: {
      message: 'splashScreen.alert.message',
      title: 'splashScreen.alert.title',
    },
  },
  vl: {
    general: {
      conditions: {
        url: 'vl.general.conditions.url',
      },
      electronicVoucher: {
        url: 'vl.general.electronicVoucher.url',
      },
      region: {
        name: 'vl.general.region.name',
      },
      serviceVouchers: {
        app: {
          label: 'vl.general.serviceVouchers.app.label',
        },
        helpCenter: {
          phoneNumber: 'vl.general.serviceVouchers.helpCenter.phoneNumber',
        },
        publicWebsite: {
          url: 'vl.general.serviceVouchers.publicWebsite.url',
        },
        website: {
          url: 'vl.general.serviceVouchers.website.url',
        },
      },
      url: {
        complaint: 'vl.general.url.complaint',
        contactAProvider: 'vl.general.url.contactAProvider',
        contactUs: 'vl.general.url.contactUs',
        cookies: 'vl.general.url.cookies',
        electronicVoucher: 'vl.general.url.electronicVoucher',
        exchange: 'vl.general.url.exchange',
        faq: 'vl.general.url.faq',
        news: 'vl.general.url.news',
        pass: 'vl.general.url.pass',
        privacyPolicy: 'vl.general.url.privacyPolicy',
        question: 'vl.general.url.question',
        termsAndConditions: 'vl.general.url.termsAndConditions',
        workFollowUp: 'vl.general.url.workFollowUp',
      },
    },
    header: {
      funcHeader: {
        cta: {
          backToInfoWebsite: {
            title: 'vl.header.funcHeader.cta.backToInfoWebsite.title',
          },
        },
      },
    },
    login: {
      url: {
        usefullLinks: {
          cantConnect: 'vl.login.url.usefullLinks.cantConnect',
          howTo: 'vl.login.url.usefullLinks.howTo',
        },
      },
    },
    register: {
      alert: {
        list: {
          livingIn: 'vl.register.alert.list.livingIn',
        },
      },
    },
  },
  wallet: {
    addNewBankAccount: 'wallet.addNewBankAccount',
    amountOfVouchers: {
      noType: 'wallet.amountOfVouchers.noType',
      withType: 'wallet.amountOfVouchers.withType',
    },
    askNewVoucher: 'wallet.askNewVoucher',
    availableElectronicVouchersCount: 'wallet.availableElectronicVouchersCount',
    bankAccount: 'wallet.bankAccount',
    electronicVouchersCount: 'wallet.electronicVouchersCount',
    expireIn: 'wallet.expireIn',
    expireToday: 'wallet.expireToday',
    expiresDateVouchers: 'wallet.expiresDateVouchers',
    includingBirthAssistance: 'wallet.includingBirthAssistance',
    introduction: 'wallet.introduction',
    ongoingRepaymentAction: {
      introduction: 'wallet.ongoingRepaymentAction.introduction',
      title: 'wallet.ongoingRepaymentAction.title',
    },
    ongoingRepaymentActionBody: 'wallet.ongoingRepaymentActionBody',
    orderNewVouchers: {
      introduction: 'wallet.orderNewVouchers.introduction',
      title: 'wallet.orderNewVouchers.title',
    },
    paperVouchersCount: 'wallet.paperVouchersCount',
    repaymentInformation: 'wallet.repaymentInformation',
    repaymentReceipt: 'wallet.repaymentReceipt',
    tableTitles: {
      family: 'wallet.tableTitles.family',
      standard: 'wallet.tableTitles.standard',
    },
    title: 'wallet.title',
    toWallet: 'wallet.toWallet',
    voucherCount: {
      maternity: 'wallet.voucherCount.maternity',
      standard: 'wallet.voucherCount.standard',
    },
    warningMessage: {
      title: 'wallet.warningMessage.title',
    },
  },
  wl: {
    brps: {
      label: 'wl.brps.label',
      url: 'wl.brps.url',
    },
    general: {
      conditions: {
        url: 'wl.general.conditions.url',
      },
      electronicVoucher: {
        url: 'wl.general.electronicVoucher.url',
      },
      helpCenter: {
        link: 'wl.general.helpCenter.link',
        phone: 'wl.general.helpCenter.phone',
      },
      region: {
        name: 'wl.general.region.name',
      },
      serviceVouchers: {
        app: {
          label: 'wl.general.serviceVouchers.app.label',
        },
        helpCenter: {
          phoneNumber: 'wl.general.serviceVouchers.helpCenter.phoneNumber',
        },
        publicWebsite: {
          url: 'wl.general.serviceVouchers.publicWebsite.url',
        },
        website: {
          url: 'wl.general.serviceVouchers.website.url',
        },
      },
      url: {
        complaint: 'wl.general.url.complaint',
        contactAProvider: 'wl.general.url.contactAProvider',
        contactUs: 'wl.general.url.contactUs',
        cookies: 'wl.general.url.cookies',
        electronicVoucher: 'wl.general.url.electronicVoucher',
        exchange: 'wl.general.url.exchange',
        faq: 'wl.general.url.faq',
        news: 'wl.general.url.news',
        pass: 'wl.general.url.pass',
        privacyPolicy: 'wl.general.url.privacyPolicy',
        question: 'wl.general.url.question',
        termsAndConditions: 'wl.general.url.termsAndConditions',
        workFollowUp: 'wl.general.url.workFollowUp',
      },
    },
    header: {
      support: {
        contactList: {
          callus: {
            description: 'wl.header.support.contactList.callus.description',
          },
        },
      },
    },
    login: {
      url: {
        usefullLinks: {
          cantConnect: 'wl.login.url.usefullLinks.cantConnect',
          howTo: 'wl.login.url.usefullLinks.howTo',
        },
      },
    },
    register: {
      alert: {
        list: {
          livingIn: 'wl.register.alert.list.livingIn',
        },
      },
    },
    siteBar: {
      title: 'wl.siteBar.title',
    },
  },
  worksHistory: {
    introduction: 'worksHistory.introduction',
    title: 'worksHistory.title',
  },
  worksManagement: {
    activities: {
      DISABLED_PERSON_TRANSPORTATION:
        'worksManagement.activities.DISABLED_PERSON_TRANSPORTATION',
      GROCERY_SHOPPING: 'worksManagement.activities.GROCERY_SHOPPING',
      HOUSEKEEPING: 'worksManagement.activities.HOUSEKEEPING',
      IRONING: 'worksManagement.activities.IRONING',
    },
    awaitingConfirmation: {
      activity: {
        label: 'worksManagement.awaitingConfirmation.activity.label',
      },
      alert: {
        automaticValidationRemainingDays: {
          toolTip:
            'worksManagement.awaitingConfirmation.alert.automaticValidationRemainingDays.toolTip',
        },
        confirmed: {
          body: 'worksManagement.awaitingConfirmation.alert.confirmed.body',
          cta: 'worksManagement.awaitingConfirmation.alert.confirmed.cta',
          title: 'worksManagement.awaitingConfirmation.alert.confirmed.title',
        },
        contestConfirmation: {
          body:
            'worksManagement.awaitingConfirmation.alert.contestConfirmation.body',
          title:
            'worksManagement.awaitingConfirmation.alert.contestConfirmation.title',
        },
        toConfirm: {
          body: 'worksManagement.awaitingConfirmation.alert.toConfirm.body',
          title: 'worksManagement.awaitingConfirmation.alert.toConfirm.title',
        },
        toValidate: {
          body: 'worksManagement.awaitingConfirmation.alert.toValidate.body',
          title: 'worksManagement.awaitingConfirmation.alert.toValidate.title',
        },
      },
      by: 'worksManagement.awaitingConfirmation.by',
      contestModal: {
        comment: 'worksManagement.awaitingConfirmation.contestModal.comment',
        commentDescription:
          'worksManagement.awaitingConfirmation.contestModal.commentDescription',
        commentRequired:
          'worksManagement.awaitingConfirmation.contestModal.commentRequired',
        description:
          'worksManagement.awaitingConfirmation.contestModal.description',
        neverHappened:
          'worksManagement.awaitingConfirmation.contestModal.neverHappened',
        title: 'worksManagement.awaitingConfirmation.contestModal.title',
      },
      cta: {
        confirm: 'worksManagement.awaitingConfirmation.cta.confirm',
        contest: 'worksManagement.awaitingConfirmation.cta.contest',
      },
      performedBy: 'worksManagement.awaitingConfirmation.performedBy',
      title: 'worksManagement.awaitingConfirmation.title',
      workDate: 'worksManagement.awaitingConfirmation.workDate',
      workTime: 'worksManagement.awaitingConfirmation.workTime',
    },
    cta: {
      details: 'worksManagement.cta.details',
      history: 'worksManagement.cta.history',
    },
    detailsModal: {
      bringsModifications: 'worksManagement.detailsModal.bringsModifications',
      comments: {
        title: 'worksManagement.detailsModal.comments.title',
      },
      description: 'worksManagement.detailsModal.description',
      details: {
        title: 'worksManagement.detailsModal.details.title',
      },
      suggestCancellation: 'worksManagement.detailsModal.suggestCancellation',
      suggestModifications: 'worksManagement.detailsModal.suggestModifications',
      title: 'worksManagement.detailsModal.title',
      you: 'worksManagement.detailsModal.you',
    },
    history: {
      alert: {
        noWorksContent: 'worksManagement.history.alert.noWorksContent',
        noWorksTitle: 'worksManagement.history.alert.noWorksTitle',
      },
      attributionDate: 'worksManagement.history.attributionDate',
      info: {
        contactProvider: 'worksManagement.history.info.contactProvider',
        processingPayment: 'worksManagement.history.info.processingPayment',
        processingVouchers: 'worksManagement.history.info.processingVouchers',
        waitingForVouchers: 'worksManagement.history.info.waitingForVouchers',
      },
      modifiedOn: 'worksManagement.history.modifiedOn',
      table: {
        activity: 'worksManagement.history.table.activity',
        date: 'worksManagement.history.table.date',
        provider: 'worksManagement.history.table.provider',
        status: 'worksManagement.history.table.status',
        time: 'worksManagement.history.table.time',
      },
      title: 'worksManagement.history.title',
      vouchersAssigned: 'worksManagement.history.vouchersAssigned',
      vouchersPartiallyAssigned:
        'worksManagement.history.vouchersPartiallyAssigned',
    },
    introduction: 'worksManagement.introduction',
    pending: {
      alert: {
        noWorksContent: 'worksManagement.pending.alert.noWorksContent',
        noWorksTitle: 'worksManagement.pending.alert.noWorksTitle',
      },
    },
    status: {
      ACTIVE_AWAITING_PAYMENT: 'worksManagement.status.ACTIVE_AWAITING_PAYMENT',
      ACTIVE_AWAITING_PROVIDER_APPROVAL:
        'worksManagement.status.ACTIVE_AWAITING_PROVIDER_APPROVAL',
      ACTIVE_AWAITING_VALIDATION:
        'worksManagement.status.ACTIVE_AWAITING_VALIDATION',
      ACTIVE_CONTESTED: 'worksManagement.status.ACTIVE_CONTESTED',
      ACTIVE_NOT_ENOUGH_VOUCHERS:
        'worksManagement.status.ACTIVE_NOT_ENOUGH_VOUCHERS',
      ACTIVE_PARTIALLY_PAID: 'worksManagement.status.ACTIVE_PARTIALLY_PAID',
      ACTIVE_WAITING_PAYMENT: 'worksManagement.status.ACTIVE_WAITING_PAYMENT',
      ACTIVE_WAITING_VALIDATION:
        'worksManagement.status.ACTIVE_WAITING_VALIDATION',
      ARCHIVED_CANCELLED: 'worksManagement.status.ARCHIVED_CANCELLED',
      ARCHIVED_OUTSIDE_SV: 'worksManagement.status.ARCHIVED_OUTSIDE_SV',
      ARCHIVED_PAID: 'worksManagement.status.ARCHIVED_PAID',
      ARCHIVED_PARTIALLY_PAID: 'worksManagement.status.ARCHIVED_PARTIALLY_PAID',
    },
    workFollowUp: {
      introduction: 'worksManagement.workFollowUp.introduction',
      title: 'worksManagement.workFollowUp.title',
      xlsTemplate: {
        mimeType: 'worksManagement.workFollowUp.xlsTemplate.mimeType',
        title: 'worksManagement.workFollowUp.xlsTemplate.title',
      },
    },
  },
};
